export const getPlanOwnerName = (name?: string | null): string => {
  const trimmed = name?.trim();
  return trimmed || "Estate Owner";
};

export const formatPossessivePlanLabel = (name?: string | null): string => {
  const fullName = getPlanOwnerName(name);

  return fullName.endsWith("s") || fullName.endsWith("S")
    ? `${fullName}’ Plan`
    : `${fullName}’s Plan`;
};

export const formatPossessiveEstatePlanLabel = (name?: string | null): string => {
  const fullName = getPlanOwnerName(name);

  return fullName.endsWith("s") || fullName.endsWith("S")
    ? `${fullName}’ estate plan`
    : `${fullName}’s estate plan`;
};